module.exports = __webpack_public_path__ + "img/cancel.ac8f141a.svg";